import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ShoppingCart from '../../components/molecules/ShoppingCart';
import { ViewRoot, ViewContent, ViewContentCenter, ViewSidebar } from '../../layout/Main/styled';
import { saveCurrentStep, updateValidStep } from '../../features/stepper/stepper-slice';
import { dynamicCustomEventTracking } from '../../lib/gtm';
import OpenTimePasswordForm from '../../components/molecules/OneTimePassword';
import { useLocation, useNavigate } from 'react-router-dom';

const QuickAccessOneTimePasswordOneTimePassword = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(saveCurrentStep('quickAccessOTP'));
    dispatch(updateValidStep({ quickAccessOTP: false }));
    dynamicCustomEventTracking.send({ dynamicEventName: 'journey_one_time_password_ag' });
    if (!location.state || !location.state.dataMethod) {
      navigate('/');
    }
  }, []);
  return (
    <>
      <ViewRoot>
        <ViewContent className="ViewContent">
          <ViewContentCenter>
            <OpenTimePasswordForm />
          </ViewContentCenter>
        </ViewContent>
        <ViewSidebar component="aside" className="ViewSidebar">
          <ShoppingCart />
        </ViewSidebar>
      </ViewRoot>
    </>
  );
};

export default QuickAccessOneTimePasswordOneTimePassword;
